import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "../components/Reveal";
import ServicesShowcase from "../components/ServicesShowcase";

export default function ServicesSection() {
  return (
    <section className="bg-[#0a0a0a] text-white">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-24 md:py-36">
        <Reveal className="max-w-2xl">
          <h2 className="font-display text-4xl md:text-6xl tracking-tighter font-medium leading-[0.98]">
            One right hand.<br />Your entire back office.
          </h2>
        </Reveal>

        <ServicesShowcase />

        <Reveal className="mt-12">
          <Link to="/solutions" className="inline-flex items-center gap-2 text-white/80 hover:text-white transition-colors" data-testid="services-see-all">
            See full breakdown <ArrowRight size={18} />
          </Link>
        </Reveal>
      </div>
    </section>
  );
}
